import React from 'react';

export const AnalyzeAssetsSorageHeader = () => {
  return <div> Analyze Assets Storage Header </div>;
};

AnalyzeAssetsSorageHeader.propTypes = {};

AnalyzeAssetsSorageHeader.defaultProps = {};
